// src/components/dashboard/NewsWidget/NewsWidget.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { profileService } from '../../../services/profileService';
import './NewsWidget.css';

const NewsWidget = () => {
  const navigate = useNavigate();
  const [newNewsCount, setNewNewsCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNewNewsCount();
  }, []);

  const fetchNewNewsCount = async () => {
    try {
      const data = await profileService.getNewNewsCount();
      setNewNewsCount(data.new_news_count || 0);
    } catch (err) {
      console.error('Error fetching new news count:', err);
      setNewNewsCount(0);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    navigate('/profile', { state: { activeTab: 'news' } });
  };

  return (
    <div className="news-widget-container">
      <button 
        className="news-icon-button" 
        onClick={handleClick}
        title={newNewsCount > 0 ? `${newNewsCount} new article${newNewsCount > 1 ? 's' : ''}` : 'No new articles'}
      >
        {/* Newspaper Icon Symbol */}
        <div className="news-symbol">
          <div className="newspaper-top"></div>
          <div className="newspaper-line line-1"></div>
          <div className="newspaper-line line-2"></div>
          <div className="newspaper-line line-3"></div>
        </div>
        
        {/* Red dot indicator when there are new news articles */}
        {newNewsCount > 0 && (
          <span className="new-indicator"></span>
        )}
      </button>
      
      <span className="widget-label">News</span>
    </div>
  );
};

export default NewsWidget;